(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fti-booking-form"] && !Shopify.designMode) return;
  try {
    
  const initializeReservation = section => {
    if (!section || section.dataset.reservationReady === 'true') return;
    section.dataset.reservationReady = 'true';
    const date = section.querySelector('[data-tour-date]');
    const today = new Date();
    if (date) date.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
    const input = section.querySelector('input[name="quantity"]');
    const change = amount => {
      const min = Number(input.min || 1);
      const max = Number(input.max || 20);
      input.value = Math.min(max, Math.max(min, Number(input.value || min) + amount));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    section.querySelector('[data-minus]')?.addEventListener('click', () => change(-1));
    section.querySelector('[data-plus]')?.addEventListener('click', () => change(1));
  };
  document.querySelectorAll('.fti-reserve').forEach(initializeReservation);
  document.addEventListener('shopify:section:load', event => initializeReservation(event.target.querySelector('.fti-reserve')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-destination-grid"] && !Shopify.designMode) return;
  try {
    
  const initializeDestinationFilters = section => {
    if (!section || section.dataset.filtersReady === 'true') return;
    section.dataset.filtersReady = 'true';
    section.querySelectorAll('[data-filter]').forEach(button => {
      button.addEventListener('click', () => {
        const key = button.dataset.filter;
        section.querySelectorAll('[data-filter]').forEach(item => item.classList.toggle('is-active', item === button));
        section.querySelectorAll('[data-card]').forEach(card => {
          card.hidden = key !== 'all-experiences' && key !== 'all' && card.dataset.category !== key;
        });
      });
    });
  };
  document.querySelectorAll('.fti-destinations').forEach(initializeDestinationFilters);
  document.addEventListener('shopify:section:load', event => initializeDestinationFilters(event.target.querySelector('.fti-destinations')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-home-chennai"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStory = root => {
      if (!root || root.dataset.storyReady === 'true') return;
      const dialog = root.querySelector('[data-story-dialog]');
      const openButton = root.querySelector('[data-story-open]');
      if (!dialog || !openButton) return;
      root.dataset.storyReady = 'true';
      openButton.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
      root.querySelectorAll('[data-story-close]').forEach(control => control.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        openButton.focus({ preventScroll: true });
      });
      root.querySelector('.fti-chennai__search')?.addEventListener('submit', event => {
        const target = document.querySelector('[data-tour-search]');
        if (!target) return;
        event.preventDefault();
        target.querySelector('input').value = event.currentTarget.querySelector('input').value;
        target.requestSubmit();
      });
    };
    document.querySelectorAll('.fti-chennai').forEach(initializeStory);
    document.addEventListener('shopify:section:load', event => initializeStory(event.target.querySelector('.fti-chennai')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-home-cinematic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = root => {
      if (!root || root.dataset.carouselReady) return;
      root.dataset.carouselReady = 'true';
      const track = root.querySelector('.fti-cinema__routes');
      root.querySelectorAll('[data-route-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const card = track?.querySelector('.fti-cinema__route');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.scrollBy({left: Number(button.dataset.routeDirection) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      });
    };
    document.querySelectorAll('.fti-cinema').forEach(initialize);
    document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('.fti-cinema')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-home-locals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLocals = root => {
    if (!root || root.dataset.interactionsReady === 'true') return;
    root.dataset.interactionsReady = 'true';
    const form = root.querySelector('[data-tour-search]');
    const cards = [...root.querySelectorAll('[data-tour-card]')];
    const status = root.querySelector('[data-search-status]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-city]').forEach(button=>button.addEventListener('click',()=>{form.querySelector('input').value=button.dataset.city;form.requestSubmit();}));
    if (form) form.addEventListener('submit', event => {
      event.preventDefault();
      const query = form.querySelector('input').value.trim().toLocaleLowerCase();
      let count = 0;
      cards.forEach(card => {
        const match = !query || card.dataset.tourCard.toLocaleLowerCase().includes(query);
        card.hidden = !match;
        if (match) count += 1;
      });
      root.querySelectorAll('[data-city]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.city.toLowerCase()===query)));
      status.textContent = count ? `${count} journey${count === 1 ? '' : 's'} to explore.` : 'No matching tour yet. Try Chennai, Delhi, Mumbai or Jaipur.';
      root.querySelector('[data-results-status]').textContent=status.textContent;
      root.querySelector('#fti-signature-tours')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    });
    const slider = root.querySelector('[data-testimonial-slider]');
    const moveSlider = direction => {
      const card = slider?.querySelector('blockquote');
      if (!slider || !card) return;
      const gap = Number.parseFloat(getComputedStyle(slider).columnGap) || 0;
      slider.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduce ? 'auto' : 'smooth' });
    };
    root.querySelector('[data-slider-prev]')?.addEventListener('click', () => moveSlider(-1));
    root.querySelector('[data-slider-next]')?.addEventListener('click', () => moveSlider(1));
    root.querySelectorAll('.fti-locals__faq details').forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('.fti-locals__faq details').forEach(other => {
          if (other !== item) other.open = false;
        });
      });
    });
    const saveButton = root.querySelector('.fti-locals__community-images button');
    if (saveButton) {
      try { saveButton.dataset.saved = localStorage.getItem('fti-saved-experience') === 'true' ? 'true' : 'false'; } catch {}
      saveButton.setAttribute('aria-pressed', saveButton.dataset.saved === 'true' ? 'true' : 'false');
    }
    saveButton?.addEventListener('click', () => {
      const saved = saveButton.dataset.saved !== 'true';
      saveButton.dataset.saved = saved ? 'true' : 'false';
      saveButton.setAttribute('aria-pressed', String(saved));
      try { localStorage.setItem('fti-saved-experience', String(saved)); } catch {}
      saveButton.setAttribute('aria-label', saved ? 'Remove saved food experience' : 'Save this food experience');
    });
    };
    document.querySelectorAll('.fti-locals').forEach(initializeLocals);
    document.addEventListener('shopify:section:load', event => initializeLocals(event.target.querySelector('.fti-locals')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-home-story-journey"] && !Shopify.designMode) return;
  try {
    
const initStoryHome = root => {
  if (!root || root.dataset.storyReady === 'true') return;
  root.dataset.storyReady = 'true';

  const moodButtons = root.querySelectorAll('[data-story-mood]');
  const tours = root.querySelectorAll('[data-tour-mood]');
  const filterNote = root.querySelector('[data-story-filter-note]');
  const toursAnchor = root.querySelector('[id^="fti-tours-"]');

  const applyMood = mood => {
    moodButtons.forEach(button => button.classList.toggle('is-active', button.dataset.storyMood === mood));
    tours.forEach(tour => {
      const values = (tour.dataset.tourMood || '').split(',');
      tour.hidden = mood && !values.includes(mood);
    });
    if (filterNote) filterNote.hidden = !mood;
    if (mood && toursAnchor) toursAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  moodButtons.forEach(button => button.addEventListener('click', () => applyMood(button.dataset.storyMood)));
  const clear = root.querySelector('[data-story-clear]');
  if (clear) clear.addEventListener('click', () => applyMood(''));

  root.querySelectorAll('[data-route-stop]').forEach(button => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-route-stop]').forEach(item => item.classList.toggle('is-active', item === button));
    });
  });

  const revealTargets = root.querySelectorAll('.fti-story-chapter > .fti-story-wrap, .fti-story-tour, .fti-story-private__copy, .fti-story-finale__copy');
  revealTargets.forEach(item => item.setAttribute('data-story-reveal', ''));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealTargets.forEach(item => observer.observe(item));
  } else {
    revealTargets.forEach(item => item.classList.add('is-visible'));
  }
};

document.querySelectorAll('.fti-story-home').forEach(initStoryHome);
document.addEventListener('shopify:section:load', event => initStoryHome(event.target.querySelector('.fti-story-home')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fti-tour-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fti-faq').forEach(section => {
    section.querySelectorAll('details').forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        section.querySelectorAll('details').forEach(other => {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
